export default __webpack_public_path__ + "static/media/attrLogoGreyMobile.18d9e285.svg";